import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
	NgbCalendar,
	NgbDateParserFormatter,
	NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { getFirebaseBackend } from 'src/app/authUtils';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { RESCHEDULE_THEADS } from 'src/app/shared/constants';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ReplacementService } from 'src/app/services/replacement/replacement.service';

@Component({
	selector: 'app-replacement-leads',
	templateUrl: './replacement-leads.component.html',
	styleUrls: ['./replacement-leads.component.scss'],
})
export class ReplacementLeadsComponent implements OnInit {
	public user;
	public showingLeads = [];
	public leads = [];
	public type: string;
	public loading = false;

	public counts: any;
	public title: string = 'Pending Replacements';

	public changeColor = ['prospect_company', 'replacement_status'];

	public tableConfig = {
		tableClass: 'table-striped table-hover',
		theadClass: 'thead-dark',
		dblclickRows: true,
	};

	public buttons = [];

	public theads = RESCHEDULE_THEADS;

	constructor(
		private dataService: OldDataService,
		public authenticationService: AuthenticationService,
		public utils: UtilsService,
		private modalService: NgbModal,
		private calendar: NgbCalendar,
		private sanitizer: DomSanitizer,
		public formatter: NgbDateParserFormatter,
		public router: Router,
		public replacementSrv: ReplacementService,
	) {
		this.type = 'Pending Replacements';
	}

	ngOnInit() {
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		this.getPendingReplacements();
		this.getCounts();
		// Get List of Pending replacements
	}

	getPendingReplacements() {
		this.title = 'Pending Replacements';
		this.leads = [];
		this.replacementSrv.getPendingReplacements().subscribe((data: any) => {
			this.leads = data.body;

			this.leads.map((lead) => {
				if (lead.campaign_active === '1') {
					lead.campaign_name = this.sanitizer.bypassSecurityTrustHtml(
						`<i class="fa fa-check" aria-hidden="true" title="Active campaign"></i> ${lead.campaign_name}`,
					);
				} else {
					lead.campaign_name = this.sanitizer.bypassSecurityTrustHtml(
						`<i class="fa fa-ban" aria-hidden="true" title="Deactivated campaign"></i> ${lead.campaign_name}`,
					);
				}
			});
		});
	}

	editLead(lead: any) {
		this.router.navigateByUrl('/lead-edit/' + lead.id);
	}

	changeRequests() {
		if (this.type === 'Pending Replacements') {
			this.type = 'Replacement Requests';
			this.getReplacementRequests();
		} else if (this.type === 'Replacement Requests') {
			this.type = 'Pending Replacements';
			this.getPendingReplacements();
		}
	}

	getReplacementRequests() {
		this.title = 'Replacements Requests';
		this.replacementSrv.getReplacementRequests().subscribe((data: any) => {
			if (data) {
				this.leads = [];
				for (let lead of data.body) {
					if (
						lead.replacement_status != '' ||
						lead.replacement_status != null
					) {
						switch (lead.replacement_status) {
							case 'Approved':
								lead.class = {
									class: 'bg-success',
									key: 'prospect_company',
								};
								break;
							case 'Replaced':
								lead.class = {
									class: 'bg-purple',
									key: 'prospect_company',
								};
								break;
							case 'Rescheduled':
								lead.class = {
									class: 'bg-grey-dark',
									key: 'prospect_company',
								};
								break;
							case 'Pending Replacement':
								lead.class = {
									class: 'bg-purple-light',
									key: 'prospect_company',
								};
								break;
							case 'Pending Reschedule':
								lead.class = {
									class: 'bg-grey-light',
									key: 'prospect_company',
								};
								break;
							case 'Reschedule Request':
								lead.class = {
									class: 'bg-grey-light',
									key: 'prospect_company',
								};
								break;
							case 'QC Calls':
								lead.class = {
									class: 'bg-oliva',
									key: 'prospect_company',
								};
								break;
							default:
								lead.class = {
									class: 'bg-success',
									key: 'prospect_company',
								};
								break;
						}
					}

					if (lead.campaign_active === '1') {
						lead.campaign_name =
							this.sanitizer.bypassSecurityTrustHtml(
								`<i class="fa fa-check" aria-hidden="true" title="Active campaign"></i> ${lead.campaign_name}`,
							);
					} else {
						lead.campaign_name =
							this.sanitizer.bypassSecurityTrustHtml(
								`<i class="fa fa-ban" aria-hidden="true" title="Deactivated campaign"></i> ${lead.campaign_name}`,
							);
					}

					this.leads.push(lead);
				}
			}
		});
	}

	getCounts() {
		this.replacementSrv.getReplacementCounts().subscribe((data: any) => {
			this.counts = data.body;
		});
	}

	getTodaySolvedReplacements() {
		this.title = 'Today Solved Pending Replacements';

		this.replacementSrv.getReplacementsTodaySolved().subscribe((data: any)=>{
			this.leads = [];
			for (let lead of data.body) {
				if (
					lead.replacement_status != '' ||
					lead.replacement_status != null
				) {
					switch (lead.replacement_status) {
						case 'Approved':
							lead.class = {
								class: 'bg-success',
								key: 'prospect_company',
							};
							break;
						case 'Replaced':
							lead.class = {
								class: 'bg-purple',
								key: 'prospect_company',
							};
							break;
						case 'Rescheduled':
							lead.class = {
								class: 'bg-grey-dark',
								key: 'prospect_company',
							};
							break;
						case 'Pending Replacement':
							lead.class = {
								class: 'bg-purple-light',
								key: 'prospect_company',
							};
							break;
						case 'Pending Reschedule':
							lead.class = {
								class: 'bg-grey-light',
								key: 'prospect_company',
							};
							break;
						case 'QC Calls':
							lead.class = {
								class: 'bg-oliva',
								key: 'prospect_company',
							};
							break;
						default:
							lead.class = {
								class: 'bg-success',
								key: 'prospect_company',
							};
							break;
					}
				}

				if (lead.campaign_active === '1') {
					lead.campaign_name =
						this.sanitizer.bypassSecurityTrustHtml(
							`<i class="fa fa-check" aria-hidden="true" title="Active campaign"></i> ${lead.campaign_name}`,
						);
				} else {
					lead.campaign_name =
						this.sanitizer.bypassSecurityTrustHtml(
							`<i class="fa fa-ban" aria-hidden="true" title="Deactivated campaign"></i> ${lead.campaign_name}`,
						);
				}
				this.leads.push(lead);
			}
		});
	}
}
